import { Link } from 'react-router';
import { Icon } from '../atoms/Icon';

export default function FinalCTA() {
  return (
    <section id="final" style={{ paddingBottom: 48 }}>
      <div className="container">
        <div style={{
          position: 'relative', overflow: 'hidden', borderRadius: 28, padding: '80px 32px',
          background: 'linear-gradient(180deg, rgba(255,126,103,.10), rgba(255,77,141,.06) 50%, rgba(99,102,241,.08))',
          border: '1px solid var(--border)', textAlign: 'center',
        }}>
          <div style={{ position: 'absolute', inset: 'auto -10% -60% -10%', height: 460, background: 'radial-gradient(ellipse at 50% 0%, rgba(255,77,141,.35), transparent 60%)', filter: 'blur(40px)', pointerEvents: 'none' }}/>
          <h2 className="h2" style={{ maxWidth: '20ch', margin: '0 auto', position: 'relative' }}>
            Start generating in <span className="grad-text">60 seconds.</span>
          </h2>
          <p className="lede" style={{ marginTop: 20, position: 'relative', maxWidth: '50ch', marginLeft: 'auto', marginRight: 'auto' }}>
            Free account. No credit card. 50 free tokens every day.
          </p>
          <div className="row gap-3" style={{ marginTop: 32, justifyContent: 'center', flexWrap: 'wrap', position: 'relative' }}>
            <Link className="btn btn-primary btn-lg" to="/register">Create free account <Icon.arrow size={14}/></Link>
            <Link className="btn btn-ghost btn-lg" to="/register">Explore models</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
